module.exports = __webpack_public_path__ + "static/UNITY-SQUARE-Two-modern_v2-6f096edcafe8f574189ebb5fb6a84001.pdf";